var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBeforeDecision(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1353.57 1006.07"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "before-decision_svg__a",
    x1: 1232.7,
    y1: 379.17,
    x2: 468.62,
    y2: 627.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#646a7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0e1932"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "before-decision_svg__b",
    x1: 1170.1,
    y1: 399.51,
    x2: 531.22,
    y2: 607.09,
    xlinkHref: "#before-decision_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "before-decision_svg__c",
    x1: 1030.31,
    y1: 444.93,
    x2: 671.01,
    y2: 561.67,
    xlinkHref: "#before-decision_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "before-decision_svg__d",
    x1: 160.48,
    y1: 107,
    x2: 4,
    y2: 157.84,
    xlinkHref: "#before-decision_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "before-decision_svg__f",
    x1: 160.48,
    y1: 292,
    x2: 4,
    y2: 342.84,
    xlinkHref: "#before-decision_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "before-decision_svg__h",
    x1: 160.48,
    y1: 477,
    x2: 4,
    y2: 527.84,
    xlinkHref: "#before-decision_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "before-decision_svg__j",
    x1: 160.48,
    y1: 662,
    x2: 4,
    y2: 712.84,
    xlinkHref: "#before-decision_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "before-decision_svg__l",
    x1: 160.48,
    y1: 847,
    x2: 4,
    y2: 897.84,
    xlinkHref: "#before-decision_svg__a"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "before-decision_svg__e"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 82.24,
    cy: 132.42,
    r: 44.83,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "before-decision_svg__g"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 82.24,
    cy: 317.42,
    r: 44.83,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "before-decision_svg__i"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 82.24,
    cy: 502.42,
    r: 44.83,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "before-decision_svg__k"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 82.24,
    cy: 687.42,
    r: 44.83,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "before-decision_svg__m"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 82.24,
    cy: 872.42,
    r: 44.83,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "before-decision_svg__n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M687.34 355.27h352.77c10.3-1.08 16.54 5.3 16.54 15.44v225.84H670.81V370.71c0-10.14 6.19-16.52 16.53-15.44z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "before-decision_svg__o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M637.73 626.34h452v11c0 5-2.44 8.5-7.41 11.53s-12.39 5-20.15 5H665.29c-7.76 0-15.19-2-20.15-5s-7.41-6.49-7.41-11.53z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "before-decision_svg__p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1306.05 503c0 251.77-204.1 455.88-455.87 455.88S396.48 754.81 396.48 503 598.41 47.16 850.18 47.16s455.87 204.1 455.87 455.84zM850.18 75.16C613.87 75.16 422.3 266.73 422.3 503s191.57 427.91 427.88 427.91S1278.05 739.34 1278.05 503 1086.49 75.16 850.18 75.16z",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 850.66,
    cy: 503.3,
    r: 401.59,
    opacity: 0.4,
    fill: "url(#before-decision_svg__a)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 850.66,
    cy: 503.3,
    r: 335.78,
    opacity: 0.4,
    fill: "url(#before-decision_svg__b)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 850.66,
    cy: 503.3,
    r: 188.84,
    opacity: 0.4,
    fill: "url(#before-decision_svg__c)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 850.66,
    cy: 503.3,
    r: 401.59,
    fill: "none",
    stroke: "#a8c0dd",
    strokeMiterlimit: 10,
    strokeWidth: 0.816
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 850.66,
    cy: 503.3,
    r: 335.78,
    fill: "none",
    stroke: "#a8c0dd",
    strokeMiterlimit: 10,
    strokeWidth: 0.816
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 850.66,
    cy: 503.3,
    r: 188.84,
    fill: "none",
    stroke: "#a8c0dd",
    strokeMiterlimit: 10,
    strokeWidth: 0.816
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1158.58,
    cy: 245.08,
    r: 10.2,
    fill: "#88929e",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 965.52,
    cy: 818.7,
    r: 8.16,
    fill: "#88929e",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 502.17,
    cy: 304.34,
    r: 7.76,
    fill: "#88929e",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 770.34,
    cy: 674.22,
    r: 6.94,
    fill: "#88929e",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 82.24,
    cy: 132.42,
    r: 82.24,
    opacity: 0.4,
    fill: "url(#before-decision_svg__d)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#before-decision_svg__e)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 89.08,
    cy: 139.26,
    r: 44.83,
    fill: "#88929e",
    opacity: 0.47
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 82.24,
    cy: 132.42,
    r: 44.83,
    fill: "none",
    stroke: "#d2e6ef",
    strokeMiterlimit: 10,
    strokeWidth: 3.914
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#d2e6ef",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.914,
    d: "M63.68 136.2l16.87 16.9 20.26-42.23"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.24,
    cy: 317.42,
    r: 82.24,
    opacity: 0.4,
    fill: "url(#before-decision_svg__f)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#before-decision_svg__g)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 89.08,
    cy: 324.26,
    r: 44.83,
    fill: "#88929e",
    opacity: 0.47
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 82.24,
    cy: 317.42,
    r: 44.83,
    fill: "none",
    stroke: "#d2e6ef",
    strokeMiterlimit: 10,
    strokeWidth: 3.914
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#d2e6ef",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.914,
    d: "M63.68 321.2l16.87 16.9 20.26-42.23"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.24,
    cy: 502.42,
    r: 82.24,
    opacity: 0.4,
    fill: "url(#before-decision_svg__h)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#before-decision_svg__i)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 89.08,
    cy: 509.26,
    r: 44.83,
    fill: "#88929e",
    opacity: 0.47
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 82.24,
    cy: 502.42,
    r: 44.83,
    fill: "none",
    stroke: "#d2e6ef",
    strokeMiterlimit: 10,
    strokeWidth: 3.914
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#d2e6ef",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.914,
    d: "M63.68 506.2l16.87 16.9 20.26-42.23"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.24,
    cy: 687.42,
    r: 82.24,
    opacity: 0.4,
    fill: "url(#before-decision_svg__j)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#before-decision_svg__k)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 89.08,
    cy: 694.26,
    r: 44.83,
    fill: "#88929e",
    opacity: 0.47
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 82.24,
    cy: 687.42,
    r: 44.83,
    fill: "none",
    stroke: "#d2e6ef",
    strokeMiterlimit: 10,
    strokeWidth: 3.914
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#d2e6ef",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.914,
    d: "M63.68 691.2l16.87 16.9 20.26-42.23"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.24,
    cy: 872.42,
    r: 82.24,
    opacity: 0.4,
    fill: "url(#before-decision_svg__l)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#before-decision_svg__m)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 89.08,
    cy: 879.26,
    r: 44.83,
    fill: "#88929e",
    opacity: 0.47
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 82.24,
    cy: 872.42,
    r: 44.83,
    fill: "none",
    stroke: "#d2e6ef",
    strokeMiterlimit: 10,
    strokeWidth: 3.914
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#d2e6ef",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.914,
    d: "M63.68 876.2l16.87 16.9 20.26-42.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.43 354.32h352.77c10.3-1.08 16.54 5.3 16.54 15.44V595.6H668.9V369.76c0-10.14 6.24-16.53 16.53-15.44zM635.83 625.38h452v11c0 5-2.44 8.5-7.41 11.53s-12.39 5-20.15 5H663.39c-7.76 0-15.19-2-20.15-5s-7.41-6.49-7.41-11.53z",
    fill: "#1d2135"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#before-decision_svg__n)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M697.34 365.27h352.77c10.3-1.08 16.54 5.3 16.54 15.44v225.84H680.81V380.71c0-10.14 6.19-16.52 16.53-15.44z",
    fill: "#88929e",
    opacity: 0.47
  })), /*#__PURE__*/React.createElement("path", {
    d: "M687.34 355.27h352.77c10.3-1.08 16.54 5.3 16.54 15.44v225.84H670.81V370.71c0-10.14 6.19-16.52 16.53-15.44z",
    fill: "none",
    stroke: "#d2e6ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#before-decision_svg__o)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M647.73 636.34h452v11c0 5-2.44 8.5-7.41 11.53s-12.39 5-20.15 5H675.29c-7.76 0-15.19-2-20.15-5s-7.41-6.49-7.41-11.53z",
    fill: "#88929e",
    opacity: 0.47
  })), /*#__PURE__*/React.createElement("path", {
    d: "M637.73 626.34h452v11c0 5-2.44 8.5-7.41 11.53s-12.39 5-20.15 5H665.29c-7.76 0-15.19-2-20.15-5s-7.41-6.49-7.41-11.53zM719.9 477.14h181.96M719.9 412.19h181.96M719.9 541.88h181.96M1004.53 394.28l-36.2.07a17.2 17.2 0 00-17.12 17.14h0a17.2 17.2 0 0017.18 17.08l36.2-.07a17.2 17.2 0 0017.12-17.14h0a17.2 17.2 0 00-17.18-17.08zM1004.53 524.16l-36.2.07a17.2 17.2 0 00-17.12 17.14h0a17.2 17.2 0 0017.18 17.08l36.2-.07a17.2 17.2 0 0017.12-17.14h0a17.2 17.2 0 00-17.18-17.08zM1004.53 459.22l-36.2.07a17.2 17.2 0 00-17.12 17.14h0a17.2 17.2 0 0017.18 17.08l36.2-.07a17.2 17.2 0 0017.12-17.14h0a17.2 17.2 0 00-17.18-17.08z",
    fill: "none",
    stroke: "#d2e6ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 969.61,
    cy: 541.27,
    rx: 8.9,
    ry: 8.88,
    transform: "rotate(-.11 968.3 542.635)",
    fill: "#88929e"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 969.61,
    cy: 476.32,
    rx: 8.9,
    ry: 8.88,
    transform: "rotate(-.11 968.364 474.922)",
    fill: "#88929e"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 969.61,
    cy: 411.38,
    rx: 8.9,
    ry: 8.88,
    transform: "rotate(-.11 968.424 412.418)",
    fill: "#88929e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#d2e6ef",
    strokeMiterlimit: 10,
    strokeWidth: 2.449,
    d: "M607.98 502.49H224.55"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d2e6ef",
    d: "M604.41 490.28l21.14 12.21-21.14 12.21v-24.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#d2e6ef",
    strokeMiterlimit: 10,
    strokeWidth: 2.449,
    d: "M147.05 132.4h66v740h-60M212.48 503.9h-66.2M212.48 686.9h-66.2M212.48 316.9h-66.2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 502.49,
    r: 10.2,
    fill: "#1d2135",
    stroke: "#d2e6ef",
    strokeMiterlimit: 10,
    strokeWidth: 2.449
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#before-decision_svg__p)",
    fill: "none",
    stroke: "#a8c0dd",
    strokeMiterlimit: 10,
    strokeWidth: 0.816
  }, /*#__PURE__*/React.createElement("path", {
    d: "M850.18 0v1006.07M1353.21 503.03H347.14M806.37 1.95l87.69 1002.24M1351.33 459.23L349.09 546.91M762.9 7.71l174.7 990.78M1345.65 415.75l-990.79 174.7M720.1 17.23l260.39 971.79M1336.19 372.93L364.4 633.32M678.29 30.45l344.1 945.39M1323.04 331.1l-945.4 344.09M637.79 47.26l425.19 911.81M1306.29 290.57L394.48 715.76M598.91 67.54l503.04 871.28M1286.07 251.66L414.79 754.7M561.95 91.13l577.06 824.12M1262.54 214.66L438.42 791.72M527.18 117.85l646.69 770.69M1235.87 179.85L465.18 826.54M494.88 147.5l711.4 711.4M1206.28 147.5l-711.4 711.4M465.28 179.85l770.69 646.69M1173.97 117.85L527.28 888.54M438.61 214.66l824.13 577.06M1139.2 91.13L562.15 915.25M415.08 251.66l871.28 503.04M1102.24 67.54L599.2 938.82M394.86 290.57l911.81 425.19M1063.36 47.26L638.18 959.07M378.12 331.1l945.39 344.09M1022.86 30.45L678.77 975.84M364.96 372.93l971.79 260.39M981.05 17.23L720.66 989.02M355.51 415.75l990.78 174.7M938.25 7.71l-174.7 990.78M349.82 459.23l1002.24 87.68M894.78 1.95L807.1 1004.19M828.3.47l43.88 1005.11M1352.79 481.09L347.68 524.97M784.62 4.33l131.31 997.46M1349.01 437.4L351.54 568.72M741.44 11.98L959.19 994.2M1341.43 394.21L359.21 611.96M699.09 23.36l302.53 959.5M1330.11 351.85l-959.5 302.53M657.9 38.39l385.01 929.49M1315.15 310.63L385.66 695.64M618.17 56.95l464.55 892.4M1296.65 270.87l-892.4 464.56M580.22 78.91l540.56 848.51M1274.75 232.88L426.24 773.44M544.32 104.09l612.45 798.16M1249.63 196.94L451.46 809.4M510.75 132.3l679.69 741.75M1221.47 163.33L479.72 843.02M479.77 163.33l741.75 679.69M1190.49 132.3L510.8 874.05M451.61 196.94l798.17 612.46M1156.92 104.09L544.46 902.25M426.49 232.88L1275 773.44M1121.02 78.91L580.46 927.42M404.59 270.87l892.39 464.56M1083.06 56.95l-464.55 892.4M386.09 310.63l929.49 385.01M1043.34 38.39L658.33 967.88M371.13 351.85l959.5 302.53M1002.14 23.36l-302.53 959.5M359.81 394.21l982.22 217.75M959.8 11.98L742.04 994.2M352.23 437.4l997.46 131.32M916.62 4.33L785.3 1001.79M348.44 481.09l1005.11 43.88M872.94.47l-43.88 1005.11"
  }))))));
}

export default __webpack_public_path__ + "static/before-decision.4e2905a5.svg";
export { SvgBeforeDecision as ReactComponent };